import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9038 10.473L24 12H12L10.5 9H23.6219C23.7455 9.48002 23.8401 9.97166 23.9038 10.473Z",
			fill: "#D80027"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9375 3C20.9095 3.85789 21.7414 4.87078 22.3946 6H10.5V3H19.9375Z",
			fill: "#D80027"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3946 18C22.9317 17.0715 23.348 16.0643 23.6219 15H0.378052C0.651987 16.0643 1.06827 17.0715 1.60539 18H22.3946Z",
			fill: "#D80027"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9375 21H4.06253C4.26979 21.1829 4.48341 21.3588 4.70303 21.5273L4.91172 21.6838C6.89782 23.14 9.34848 24 12 24C15.0433 24 17.8221 22.8671 19.9375 21Z",
			fill: "#D80027"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 0C5.37258 0 0 5.37258 0 12H12V0Z",
			fill: "#0052B4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.80371 5.66953C1.97281 5.39773 2.15248 5.1332 2.34214 4.87649L2.60331 5.67188H3.84375L2.84031 6.39365L3.23438 7.59375L2.20312 6.85197L1.17188 7.59375L1.56594 6.39365L1.43704 6.30093C1.55256 6.08726 1.67438 5.87749 1.80225 5.67188L1.80371 5.66953Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.97443 2.27054C5.17563 2.125 5.38151 1.98556 5.59182 1.85247C5.60468 1.84433 5.61756 1.83622 5.63045 1.82812C5.84137 1.69577 6.05671 1.56979 6.27618 1.45046L6.40019 1.82812H7.64062L6.63719 2.5499L7.03125 3.75L6 3.00822L4.96875 3.75L5.36281 2.5499L4.97443 2.27054Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.79688 10.6488L8.76562 11.3906L9.15969 10.1905L8.15625 9.46875H9.39669L9.79688 8.25L10.1971 9.46875H11.4375L10.4341 10.1905L10.8281 11.3906L9.79688 10.6488Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 10.6488L4.96875 11.3906L5.36281 10.1905L4.35938 9.46875H5.59981L6 8.25L6.40019 9.46875H7.64062L6.63719 10.1905L7.03125 11.3906L6 10.6488Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.20312 10.6488L1.17188 11.3906L1.56594 10.1905L0.5625 9.46875H1.80294L2.20312 8.25L2.60331 9.46875H3.84375L2.84031 10.1905L3.23438 11.3906L2.20312 10.6488Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.79688 6.85197L8.76562 7.59375L9.15969 6.39365L8.15625 5.67188H9.39669L9.79688 4.45312L10.1971 5.67188H11.4375L10.4341 6.39365L10.8281 7.59375L9.79688 6.85197Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 6.85197L4.96875 7.59375L5.36281 6.39365L4.35938 5.67188H5.59981L6 4.45312L6.40019 5.67188H7.64062L6.63719 6.39365L7.03125 7.59375L6 6.85197Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.79688 3.00822L8.76562 3.75L9.15969 2.5499L8.15625 1.82812H9.39669L9.79688 0.609375L10.1971 1.82812H11.4375L10.4341 2.5499L10.8281 3.75L9.79688 3.00822Z",
			fill: "#EEEEEE"
		})
	] }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2003_27268",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export { SvgUs as ReactComponent };
